






















































import _ from 'lodash'
//状態監視用にwatchを追加 issue:724
import { Component, Mixins, Watch } from 'vue-property-decorator'
import {
  TCWApiError,
  TCWBadDataStructureError,
  TCWBaseError,
  TCWUnexpectedError
} from '@/plugins/TCWBaseError'
import * as ApiPath from '@/tcw/constant/ApiPath'
import { ERR_CODE_WEB_API_NOT_FOUND } from '@/tcw/constant/ErrorCode'
import Getsudo from '@/tcw/domain/Getsudo'
import { ApiErrorCode, ApiGeneralPayload, ApiGeneralSinglePayload } from '@/tcw/api/types'
import BasePage from '@/tcw/components/BasePage'
import DataGetComponent from '@/tcw/components/DataGetComponent'
import TcwLayoutBasicTemplate from '@/layout/TcwLayoutBasicTemplate.vue'
import { KintaiActionMenu } from '@/components/kintai/types'
import KintaiGetsudoDataView from '@/components/kintai/organisms/KintaiGetsudoDataView.vue'
import KintaiLocalHeader from '@/components/kintai/molecules/KintaiLocalHeader.vue'

@Component({
  components: {
    TcwLayoutBasicTemplate,
    KintaiGetsudoDataView,
    KintaiLocalHeader
  }
})
export default class KintaiListPage extends Mixins(BasePage, DataGetComponent) {
  private initDialogVisible = false
  private isInited = true
  private isCreating = false
  private processingAction = false

  private teishutsu: ApiGeneralSinglePayload | null = null
  private shouninInfo: ApiGeneralPayload | null = null

  private deleteMode = false
  private selectedDates: string[] = []

  // ロック中の動作、削除 UI も削除対象データも強制リセット issue:724
  @Watch('isTeishutsuLock')
  private onLockChanged(nowLocked: boolean) {
    if (nowLocked && this.deleteMode) {
      this.deleteMode = false
      this.selectedDates = []
      this.$tcw.message({
        type: 'info',
        message: 'ロック中のため削除モードを終了しました'
      })
    }
  }
  // モード切替で削除モードを安全に終了 issue:724 TODO:モバイルモード
  @Watch('isMobile')
  private onViewportChanged(nowMobile: boolean) {
    if (nowMobile && this.deleteMode) {
      this.deleteMode = false
      this.clearSelectedUI() // 内部配列＆表のチェックを同時にクリア
      this.$tcw.message({ type: 'info', message: 'モバイル表示のため削除モードを終了しました' })
    }
  }

  get apiPath(): string {
    return ApiPath.buildPath(ApiPath.Paths.Teishutsu.get, {
      year: this.currentGetsudo.yearValue,
      month: this.currentGetsudo.monthValue
    })
  }

  /*****************
   * 提出情報関連
   *****************/
  get hasTeishutsu(): boolean {
    if (this.teishutsu === null) {
      return false
    }
    if (Array.isArray(this.teishutsu)) {
      throw new TCWBadDataStructureError()
    }
    return this.teishutsu.id !== undefined && this.teishutsu.id !== null
  }
  get isTeishutsuLock(): boolean {
    if (!this.hasTeishutsu || !this.teishutsu) {
      return false
    }
    if (typeof this.teishutsu.isLock !== 'boolean') {
      return false
    }
    return this.teishutsu.isLock
  }
  get genzaiLevel(): number {
    if (this.teishutsu === null) {
      return -1
    }
    if (Array.isArray(this.teishutsu)) {
      throw new TCWBadDataStructureError('提出情報が配列構造になっています')
    }
    if (!this.teishutsu.genzaiLevel) {
      return -1
    }
    const genzaiLevel = Number(this.teishutsu.genzaiLevel)
    if (isNaN(genzaiLevel)) {
      throw new TCWBadDataStructureError('現在レベルが数値でありません')
    }
    return genzaiLevel
  }
  get isFirstLevel(): boolean {
    return this.genzaiLevel <= 0
  }
  get hasShouninTask(): boolean {
    if (this.shouninInfo === null || _.isArray(this.shouninInfo)) {
      return false
    }
    if (!_.isArray(this.shouninInfo.abailableActionList)) {
      return false
    }
    return this.shouninInfo.abailableActionList.length > 0
  }
  get isKanryo(): boolean {
    if (this.isLoading) {
      return false
    }
    return this.teishutsu?.status === '3'
  }

  protected async beforeProc(): Promise<void> {
    this.isInited = false
    this.teishutsu = null
    this.shouninInfo = [] // 承認タスクをクリア
  }

  protected async afterProc(): Promise<void> {
    // プロジェクト情報が設定されているか確認
    if (!this.hasProject) {
      const answer = await this.$tcw.confirm({
        type: 'info',
        title: 'プロジェクト情報の設定',
        message: 'プロジェクト設定画面より定時時間、業務内容などを登録してください。',
        canCancel: false
      })
      if (answer) this.$router.push('/settei/project')
    }

    // // 承認タスクを確認
    await this.fetchShouninTask()

    return Promise.resolve()
  }
  protected responseInitWebApi(response: ApiGeneralPayload): void {
    this.teishutsu = response as ApiGeneralSinglePayload
  }

  protected async errorProc(e: Error): Promise<void> {
    if (e instanceof TCWApiError) {
      const errorCode = e.getErrorCode()
      if (errorCode === ERR_CODE_WEB_API_NOT_FOUND) {
        // 未初期化ならダイアログを表示
        this.initDialogVisible = true
        return
      }
    }

    await this.defaultErrorProc(e)
  }

  /**
   * 承認情報をサーバから取得する
   */
  private async fetchShouninTask(): Promise<void> {
    // APIリクエスト情報を作成
    const keyInfo = {
      year: this.currentGetsudo.yearValue,
      month: this.currentGetsudo.monthValue,
      userId: this.loginUserId ? this.loginUserId : ''
    }
    const path = ApiPath.buildPath(ApiPath.Paths.ShouninInput.get, keyInfo)

    console.log('指定された月度の承認タスクの取得', keyInfo)

    // APIを実行する
    try {
      const response: ApiGeneralPayload = await this.getWebApi().call<ApiGeneralPayload>(
        path,
        'GET'
      )
      this.shouninInfo = response
    } catch (e) {
      if (e instanceof TCWApiError && e.getStatusCode() === 404) {
        console.log('現在承認タスクはありません')
      } else {
        throw e
      }
    }
  }

  /**
   * 勤怠の入力チェックを行う
   */
  private async checkKintaiInput(): Promise<ApiErrorCode> {
    try {
      this.processingAction = true
      const view = (this.$refs.view as unknown) as { doCheckProc: () => Promise<ApiErrorCode> }
      if (!view || typeof view.doCheckProc !== 'function') {
        throw new TCWUnexpectedError('勤怠一覧コンポーネントが描画されていません')
      }
      const checkResult = await view.doCheckProc()
      return checkResult
    } finally {
      this.processingAction = false
    }
  }

  cancelInit(): void {
    this.initDialogVisible = false
  }
  protected async execInit(): Promise<void> {
    this.initDialogVisible = false
    // 削除モードの状態を初期化 isuee:724
    this.clearSelectedUI()
    this.isCreating = true
    this.isLoading = true
    this.processingAction = true

    const patternId = this.project?.kintaiPatternId
    if (patternId === undefined || patternId === null) {
      // デフォルト勤怠パターンが未設定の場合は設定画面へ遷移
      this.$tcw.message({
        type: 'info',
        message: 'プロジェクト設定を行ってデフォルト勤怠パターンを登録してください'
      })
      this.$router.push('/settei/project')
    }

    this.$tcw.message({
      type: 'info',
      message: '初期化を開始します'
    })
    const url = ApiPath.buildPath(ApiPath.Paths.KintaiMonth.init, {
      year: this.currentGetsudo.yearValue,
      month: this.currentGetsudo.monthValue,
      patternId: String(patternId)
    })

    try {
      await this.getWebApi().call<ApiGeneralPayload>(url, 'POST')
      this.isInited = true
      this.isCreating = false
    } catch (e) {
      // this.defaultErrorProc(e)
    } finally {
      this.isLoading = false
      this.processingAction = false
    }
  }
  private async nextMonth(): Promise<void> {
    this.$tcw.$store.basic.nextMonth()
    this.changeTarget()
  }
  private async prevMonth(): Promise<void> {
    this.$tcw.$store.basic.prevMonth()
    this.changeTarget()
  }
  private async toThisMonth(): Promise<void> {
    const getsudo = Getsudo.now(this.shimebi)
    this.$tcw.$store.basic.setTargetDate(getsudo.getDate())
    this.changeTarget()
  }
  private async selectMonth(getsudo: Getsudo): Promise<void> {
    console.log('selectMonth')
    const selectMonthDate = getsudo.getDate()
    this.$tcw.$store.basic.setTargetDate(selectMonthDate)
    this.changeTarget()
  }
  private async changeTarget(): Promise<void> {
    // 勤怠チェックモードは一旦解除
    this.$tcw.$store.basic.setKintaiCheckMode(false)
    // 月切り替え時に削除モードをクリア isuee:724
    this.deleteMode = false
    this.clearSelectedUI()
    await this.init()
  }
  private async clearKintaiCheckMode(): Promise<void> {
    // 勤怠チェックモードは一旦解除
    this.$tcw.$store.basic.setKintaiCheckMode(false)
    await this.init()
  }
  /**
   * アクション
   */
  get abailableActions(): KintaiActionMenu[] {
    const actions: KintaiActionMenu[] = []
    // モバイルでは削除系UIを出さない issue:724 TODO:モバイルモード
    const canUseDelete = !this.isTeishutsuLock && !this.isMobile

    // 一括設定
    if (this.isFirstLevel) {
      // 自分自身の勤怠データ、かつ、まだ承認依頼を出していない
      actions.push({
        id: 1,
        category: 'common',
        label: '一括設定',
        command: 'bulkApply',
        icon: 'input'
      })
    }

    // 入力チェック
    if (this.isFirstLevel) {
      // 自分自身の勤怠データ、かつ、まだ承認依頼を出していないか
      actions.push({
        id: 2,
        category: 'flow',
        label: '入力チェック',
        command: 'execCheck',
        icon: 'rule'
      })
    }

    // 提出情報登録
    if (!this.hasTeishutsu) {
      // 自分自身の勤怠データ、かつ、提出情報未登録
      actions.push({
        id: 3,
        category: 'flow',
        label: '提出情報登録',
        command: 'execTeishutsu',
        icon: 'present_to_all'
      })
    }

    // 提出情報修正
    if (this.hasTeishutsu && !this.isTeishutsuLock) {
      // 自分自身の勤怠データ、かつ、提出情報登録済み、勤怠情報ロック済み
      actions.push({
        id: 4,
        category: 'flow',
        label: '提出情報修正',
        command: 'updateTeishutsu',
        icon: 'present_to_all'
      })
    }

    // 承認フロー
    if (this.hasShouninTask) {
      // 承認タスクがあるかどうか
      actions.push({
        id: 5,
        category: 'flow',
        label: '承認フロー',
        command: 'execShounin',
        icon: 'approval'
      })
    }

    // 承認フロー完了解除
    if (this.isKanryo) {
      actions.push({
        id: 7,
        category: 'flow',
        label: '完了解除',
        command: 'execKanryoKaijo',
        icon: 'approval'
      })
    }

    actions.push({
      id: 6,
      category: 'output',
      label: 'Excel出力',
      command: 'exportExcel',
      icon: 'file_download'
    })
    actions.push({
      id: 8,
      category: 'output',
      label: '遅延証明書出力',
      command: 'exprotChienShoumei',
      icon: 'file_download'
    })

    // ロック解除 & PC のみ「削除モード」「選択削除」を出す issue:724 TODO:モバイルモード
    if (canUseDelete) {
      actions.push({
        id: 9,
        category: 'deleteMode',
        label: this.deleteMode ? '削除モード解除' : '削除モード',
        command: 'toggleDeleteMode',
        icon: this.deleteMode ? 'cancel' : 'delete'
      })

      // 選択削除（削除モード中のみ表示、選択0件ならdisabled）issue:724
      if (this.deleteMode) {
        actions.push({
          id: 10,
          category: 'deleteMode',
          label: `選択削除${this.selectedDates.length ? `（${this.selectedDates.length}件）` : ''}`,
          command: 'deleteSelected',
          icon: 'delete_forever',
          // 選択件数が 0 件の時はボタンを押せないようにする。issue:724
          disabled: this.selectedDates.length === 0
        } as any)
      }
    }

    return actions
  }
  // 内部配列とUI（ag-Grid）の選択を同時にクリアする isuee:724
  private clearSelectedUI(): void {
    // 内部配列をクリア
    this.selectedDates = []
    // DataView → Table へ委譲してUIのチェックも外す
    const view = this.$refs.view as any // <kintai-getsudo-data-view ref="view">
    if (view && typeof view.clearSelection === 'function') {
      view.clearSelection()
    }
  }

  private async execAction(command: string): Promise<void> {
    let checkResult: ApiErrorCode = 'NONE'
    switch (command) {
      // 削除モードonoff切替分岐 issue:724
      case 'toggleDeleteMode':
        // ロック中は操作させない issue:724
        if (this.isTeishutsuLock) {
          this.$tcw.message({ type: 'warning', message: 'ロック中は削除モードを使用できません' })
          return
        }
        // 切り替え(booleanを反転) issue:724
        this.deleteMode = !this.deleteMode
        // OFF時に初期化 issue:724
        if (!this.deleteMode) this.selectedDates = []
        this.$tcw.message({
          type: 'info',
          message: this.deleteMode ? '削除モードをONにしました' : '削除モードをOFFにしました'
        })
        break

      // 選択削除の実際の実行 issue:724
      case 'deleteSelected':
        // 選択0では実行させない issue:724
        if (this.selectedDates.length === 0) {
          this.$tcw.message({ type: 'warning', message: '削除対象の日付を選択してください' })
          break
        }
        {
          const ok = await this.$tcw.confirm({
            type: 'error',
            title: '選択した勤怠を削除しますか？',
            message: `選択件数：${this.selectedDates.length} 件(※この操作は取り消せません)`
          })
          if (!ok) break
          //削除API呼び出し /kintai/bulk-delete awaitで処理が終わるまで待機 issue:724
          const path = '/kintai/bulk-delete'
          await this.getWebApi().call<any>(path, 'POST', {
            year: this.currentGetsudo.yearValue,
            month: this.currentGetsudo.monthValue,
            days: this.selectedDates // ["2025-10-01", "2025-10-02", ...] が入っている issue:724
          })

          // 成功メッセージ issue:724
          this.$tcw.message({
            type: 'success',
            message: `${this.selectedDates.length} 件の勤怠を削除しました`
          })
          // 選択状態クリア＆画面クリア＆再取得(削除結果反映) issue:724
          this.clearSelectedUI()
          await this.init()
        }
        break
      case 'bulkApply':
        // 一括設定後に選択の残りを防止 isuee:724
        this.clearSelectedUI()
        this.initDialogVisible = true
        break
      case 'execCheck':
        checkResult = await this.checkKintaiInput()
        // 入力チェック後に選択の残りを防止 isuee:724
        this.clearSelectedUI()
        this.openCheckMessage(checkResult)
        break
      case 'execTeishutsu':
        this.$router.push(
          `/teishutsu/${this.currentGetsudo.yearValue}/${this.currentGetsudo.monthValue}`
        )
        break
      case 'updateTeishutsu':
        this.$router.push(
          `/teishutsu/${this.currentGetsudo.yearValue}/${this.currentGetsudo.monthValue}`
        )
        break
      case 'execShounin':
        this.$router.push(
          `/shounin/${this.currentGetsudo.yearValue}/${this.currentGetsudo.monthValue}`
        )
        break
      case 'execKanryoKaijo':
        this.breakKanryo()
        break
      case 'exportExcel':
        this.exportCsvGetsudo()
        break
      case 'exprotChienShoumei':
        this.exprotChienShoumei()
        break
      default:
        console.log(`未対応のコマンド: ${command}`)
        break
    }
  }
  protected async breakKanryo(): Promise<void> {
    if (!this.loginUserId) {
      return
    }
    const confirm = await this.$tcw.confirm({
      type: 'error',
      title: '完了済みのフローを解除しますか？',
      message: `完了後に修正が必要な場合のみ解除してください。`
    })
    if (!confirm) {
      return
    }
    try {
      this.isLoading = true
      const path = ApiPath.buildPath(ApiPath.Paths.KanryoKaijo.post, {
        year: this.currentGetsudo.yearValue,
        month: this.currentGetsudo.monthValue,
        userId: this.loginUserId
      })
      await this.getWebApi().call<ApiGeneralSinglePayload>(path, 'GET')
      this.$tcw.message({
        type: 'success',
        title: '完了済みフローを解除しました',
        message:
          '承認フローアクションから提出者まで差戻・取下をすると修正ができます。修正後は再度フローを実行して完了してください。'
      })
      this.init()
    } catch (e) {
      let message = ''
      if (e instanceof TCWBaseError) {
        message = `[${e.getErrorCode()}]${e.outputMessage()}`
      } else {
        message = '不明なエラー'
      }
      this.$tcw.message({
        type: 'error',
        title: 'ファイルアップロードに失敗しました。',
        message
      })
    } finally {
      this.isLoading = false
    }
  }
  protected async exportCsvGetsudo(): Promise<void> {
    try {
      this.processingAction = true
      const path = ApiPath.buildPath(ApiPath.Paths.Export.getsudo, {
        year: this.currentGetsudo.yearValue,
        month: this.currentGetsudo.monthValue
      })
      const response = await this.getWebApi().callRaw<string>(
        path,
        'GET',
        {},
        { responseType: 'blob' }
      )

      let fileName = this.tcw.getDecodedFileNameFromHeader(response.headers)
      if (fileName === null) {
        fileName = 'TCard_Excel.zip'
      }
      this.tcw.execDownloadFile(fileName, response.data)
    } catch (e) {
      let message = ''
      if (e instanceof TCWBaseError) {
        message = `[${e.getErrorCode()}]${e.outputMessage()}`
      } else {
        message = '不明なエラー'
      }
      this.$tcw.message({
        type: 'error',
        title: 'Exceファイルの取得に失敗しました',
        message
      })
    } finally {
      this.processingAction = false
    }
  }
  protected async exprotChienShoumei(): Promise<void> {
    try {
      this.processingAction = true
      const path = ApiPath.buildPath(ApiPath.Paths.ExportChienShoumei.getsudo, {
        year: this.currentGetsudo.yearValue,
        month: this.currentGetsudo.monthValue
      })
      const response = await this.getWebApi().callRaw<string>(
        path,
        'GET',
        {},
        { responseType: 'blob' }
      )

      let fileName = this.tcw.getDecodedFileNameFromHeader(response.headers)
      if (fileName === null) {
        fileName = '遅延証明書.zip'
      }
      this.tcw.execDownloadFile(fileName, response.data)
    } catch (e) {
      let title = '遅延証明書の取得に失敗しました'
      let message = ''
      if (e instanceof TCWApiError) {
        if (e.getStatusCode() === 404) {
          title = '遅延証明書は登録されていません'
        } else {
          message = `[${e.getErrorCode()}]${e.outputMessage()}`
        }
      } else {
        message = '予期せぬエラー'
      }
      this.$tcw.message({ type: 'error', title, message })
    } finally {
      this.processingAction = false
    }
  }

  private openCheckMessage(resultCode: ApiErrorCode): void {
    switch (resultCode) {
      case 'ERROR':
        this.$tcw.message({
          type: 'error',
          title: '勤怠データにエラーがあります',
          message: 'エラー行を確認し修正してください。'
        })
        break
      case 'WARN':
        this.$tcw.message({
          type: 'warning',
          title: '勤怠データに警告があります',
          message:
            '警告内容を確認し、必要に応じて修正してください。問題なければそのまま承認フローを実行してください。'
        })
        break
      case 'NONE':
        this.$tcw.message({
          type: 'success',
          title: 'チェックOK',
          message: '提出・承認依頼が可能です。アクションボタンから実行してください。'
        })
        break
    }
  }
}
